import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';

import { initializeApp } from './app/app.module';
import { AppComponent } from './app/app.component';
import { BlocksModule } from './app/blocks/blocks.module';
import { TourMatMenuModule } from 'ngx-ui-tour-md-menu';
import { MatButtonModule } from '@angular/material/button';
import { MatMenuModule } from '@angular/material/menu';
import { MatIconModule } from '@angular/material/icon';
import { CommonModule } from '@angular/common';
import { provideAnimations } from '@angular/platform-browser/animations';
import { withInterceptorsFromDi, provideHttpClient, HTTP_INTERCEPTORS } from '@angular/common/http';
import { AppRoutingModule } from './app/app-routing.module';
import { Router } from '@angular/router';
import { BrowserModule, bootstrapApplication } from '@angular/platform-browser';
import { APP_INITIALIZER, importProvidersFrom } from '@angular/core';
import { GeneralService } from './app/services/general.service';
import { MAT_SNACK_BAR_DEFAULT_OPTIONS } from '@angular/material/snack-bar';
import { ToasterServiceService } from './app/services/toaster-service.service';
import { HelperService } from './app/services/helper.service';
import { httpInterceptorInterceptor } from './app/http-interceptor.interceptor';
import { AuthInterceptor } from './app/services/auth-interceptor.service';
import { AuthService } from './app/services/auth.service';
import { OAuthModule } from 'angular-oauth2-oidc';


bootstrapApplication(AppComponent, {
    providers: [
        importProvidersFrom(BrowserModule, AppRoutingModule, CommonModule, MatIconModule, MatMenuModule, MatButtonModule, TourMatMenuModule, BlocksModule,  OAuthModule.forRoot()),
        HelperService, ToasterServiceService,
        { provide: MAT_SNACK_BAR_DEFAULT_OPTIONS, useValue: { duration: 3000 } },
        GeneralService,
        AuthService,
        {
            provide: APP_INITIALIZER,
            useFactory: initializeApp,
            deps: [GeneralService, AuthService, Router],
            multi: true
        },
        provideHttpClient(withInterceptorsFromDi()),
        { provide: HTTP_INTERCEPTORS, useClass: httpInterceptorInterceptor, multi: true },
        { provide: HTTP_INTERCEPTORS, useClass: AuthInterceptor, multi: true },
        provideAnimations()
    ]
})
  .catch(err => console.error(err));
